import React from 'react'
import PropTypes from 'prop-types'
import UGLayout from '../../../helpers/UGLayout'
import C006 from '../../isolated/C006/C006'

/** 
  UG002 is a Universal Grid, which is a highly customisable grid 
  that can be easily edited by the authors. 
  The mobile layout can be set to either stack or slider and 
  it can hold 1-4 components, arranged in a row spanning equal widths.
* */
const UG002 = ({
  children,
  consumingGridType,
  categoryId,
  included,
  onLinkClick,
  imageStyle,
  isVertical,
  mobileLayout,
  meganav
}) => {
  const minLength = 1
  const maxLength = 6
  const childrenArray = Array.isArray(children) ? children : [children]

  // filter out the objects without any data
  const validIncluded = included?.filter((component) => Object.keys(component).length > 0)
  const numberOfComponents = validIncluded ? validIncluded?.length : childrenArray?.length

  // check for citrus content
  const isSponsoredContent = validIncluded?.some((component) => component.citrus)

  if (numberOfComponents < minLength || numberOfComponents > maxLength) return null

  const props = {
    childrenArray,
    consumingGridType,
    categoryId,
    included: validIncluded,
    onLinkClick,
    imageStyle,
    isVertical,
    mobileLayout,
    meganav
  }

  const showHeading = isSponsoredContent && !meganav

  return (
    <>
      {showHeading && <C006 heading='Sponsored' textAlignment='left' />}
      <UGLayout {...props} />
    </>
  )
}

UG002.propTypes = {
  /** Child components passed down from consumer app */
  children: PropTypes.node,
  /** name of the grid passed down to child components. defaults to ug002 */
  consumingGridType: PropTypes.string,
  /** categoryId passed down to child components. Used by components on argos browse */
  categoryId: PropTypes.string,
  /** Array of child components to be rendered inside the grid */
  included: PropTypes.arrayOf(PropTypes.shape),
  /** function passed down to child components */
  onLinkClick: PropTypes.func,
  /** imageStyle passed down to child components */
  imageStyle: PropTypes.oneOf(['normal', 'short', 'square', 'portrait', 'icon']),
  /* displays content in a vertical stack when true */
  isVertical: PropTypes.bool,
  /** layout of the grid components when displayed on smaller screen devices  */
  mobileLayout: PropTypes.oneOf(['stack', 'slider']),
  /** set to true when UG002 used in a meganav */
  meganav: PropTypes.bool
}

UG002.defaultProps = {
  categoryId: '',
  consumingGridType: 'ug002',
  isVertical: false,
  mobileLayout: 'stack',
  onLinkClick: null,
  imageStyle: 'normal',
  meganav: false
}

export default UG002
